//* 组件库
import type { UiTableOption2 } from "various-ui";
//* 组件属性
import type { ModuleDrug, ModuleData } from "../index";

export const useComposable = () => {
    //* 获取i18n
    const i18n = useI18n();

    //* 获取route
    const route = useRoute();

    //* 表格配置项
    const option: UiTableOption2[] = [
        { key: "type", name: i18n.t("Type"), align: "singularity" },
        { key: "name", name: i18n.t("Name2"), align: "singularity" },
        { key: "mgi_id", name: "MGI", align: "singularity" },
        { key: "strain", name: i18n.t("StrainOrigin"), align: "singularity" },
        { key: "reference_count", name: i18n.t("Publications"), align: "singularity", sort: true },
        { key: "mutation", name: i18n.t("MutationsType"), align: "singularity" },
    ];

    //* 响应式变量
    const refs = {
        //* 关键词搜索配置
        keyword: ref<string>(""),
        sort: ref<{ key: string; value: string }>({ key: "", value: "" }),

        //* 页面数据
        data: ref<ModuleDrug[]>([]),
        page: ref<number>(1),
        count: ref<number>(0),

        //* 页面状态配置
        exist: ref<boolean>(true),
        loading: ref<boolean>(true),
    };

    //* 节点
    const nodes = {
        container: ref<HTMLDivElement>(),
    };

    //* 静态变量
    const variable = { keyword: "" };

    //* 函数列表
    const methods = {
        //* 渲染函数
        render: (data: ModuleData) => {
            //* 数据初始化
            refs.data.value = data.data;
            refs.count.value = data.count;
            refs.loading.value = false;
        },

        //* 隐藏函数
        hidden: () => {
            refs.exist.value = false;
            refs.loading.value = false;
        },

        //* 搜索函数
        search: () => {
            const keyword = refs.keyword.value.trim();
            if (!refs.loading.value) {
                //* 数据更新
                variable.keyword = keyword;
                //* 接口请求
                methods.acquire(1);
            }
        },

        //* 数据获取
        acquire: (number?: number) => {
            //* 数据更新
            refs.loading.value = true;
            refs.page.value = number || refs.page.value;

            //* 排序初始化
            let sort = refs.sort.value.value == "desc" ? "-" : "";
            //* 接口请求
            api.frontend(`/api/gene/models`, {
                data: {
                    id: route.params.id,
                    sort: sort + refs.sort.value.key,
                    page: refs.page.value,
                    keyword: variable.keyword,
                },
                success: (response) => {
                    refs.data.value = response?.data || [];
                    refs.count.value = response?.count || 0;
                    //* 位置移动
                    if (nodes.container.value && scrollTo) {
                        scrollTo({ top: nodes.container.value.offsetTop - 200, behavior: "smooth" });
                    }
                },
                finally: () => {
                    refs.loading.value = false;
                },
            });
        },

        sort: (result: { key: string; value: string }) => {
            //* 数据更新
            refs.sort.value = result;
            //* 数据获取
            methods.acquire(1);
        },
    };

    return { refs, nodes, option, methods };
};
